<template>
    <div class="container">
        <form action="" class="contact-form">
            <h3 class="contact-form__title">Dados de contato</h3>
            <div class="form-group-personal">
                <div class="form-group-personal__name">
                    <input v-model="name" type="text" id="form_name">
                    <label for="form_name">Nome</label>
                </div>
            </div>
            <div class="form-group-info">
                <div class="form-group-info__email">
                    <input v-model="email" type="email" id="form_email" :style="{borderColor: emailError}">
                    <label for="form_email">E-mail</label>
                </div>
                <div class="form-group-info__tel">
                    <the-mask :mask="['(##) ####-####', '(##) #####-####']" v-model="tel" type="tel"
                              id="form_tel"/>
                    <label for="form_tel">Telefone</label>
                </div>
            </div>
            <div class="form-group-info">
                <div class="form-group-info__cidade">
                    <input v-model="cidade" type="cidade" id="form_cidade">
                    <label for="form_cidade">Cidade</label>
                </div>
                <div class="form-group-info__estados">
                    <select v-model="estado" name="form_estado" id="form_estado">
                        <option v-for="estado in estados" :key="estado.text" :value="estado.value">
                            {{estado.text}}
                        </option>
                    </select>
                    <label for="form_estado">Estado</label>,
                </div>
            </div>
            <div class="form-group-msg">
                <textarea v-model="mensagem" name="form_msg" id="form_msg"></textarea>
                <label for="form_msg">Mensagem</label>
            </div>
            <div class="form-group-btn">
                <button class="send_btn" @click.prevent="sendMessage" type="submit">{{buttonText}}</button>
            </div>
        </form>
        <ModalConfirm :show="show" :msg="msg"/>
    </div>
</template>

<script>
    import {TheMask} from 'vue-the-mask';
    import ModalConfirm from "../../Shared/ModalConfirm";
    import {required, minLength, maxLength, email} from 'vuelidate/lib/validators';

    export default {
        name: "ContactForm",
        data() {
            return {
                buttonText: 'Enviar mensagem',
                estados: [
                    {text: 'Selecione seu estado', value: null},
                    {text: 'Acre', value: 'Acre'},
                    {text: 'Alagoas', value: 'Alagoas'},
                    {text: 'Amapá', value: 'Amapá'},
                    {text: 'Amazonas', value: 'Amazonas'},
                    {text: 'Bahia', value: 'Bahia'},
                    {text: 'Ceará', value: 'Ceará'},
                    {text: 'Distrito Federal', value: 'Distrito Federal'},
                    {text: 'Espírito Santo', value: 'Espírito Santo'},
                    {text: 'Goías', value: 'Goías'},
                    {text: 'Maranhão', value: 'Maranhão'},
                    {text: 'Mato Grosso', value: 'Mato Grosso'},
                    {text: 'Mato Grosso do Sul', value: 'Mato Grosso do Sul'},
                    {text: 'Minas Gerais', value: 'Minas Gerais'},
                    {text: 'Pará', value: 'Pará'},
                    {text: 'Paraíba', value: 'Paraíba'},
                    {text: 'Paraná', value: 'Paraná'},
                    {text: 'Pernambuco', value: 'Pernambuco'},
                    {text: 'Piauí', value: 'Piauí'},
                    {text: 'Rio de Janeiro', value: 'Rio de Janeiro'},
                    {text: 'Rio Grande do Norte', value: 'Rio Grande do Norte'},
                    {text: 'Rio Grande do Sul', value: 'Rio Grande do Sul'},
                    {text: 'Rondônia', value: 'Rondônia'},
                    {text: 'Roraíma', value: 'Roraíma'},
                    {text: 'Santa Catarina', value: 'Santa Catarina'},
                    {text: 'São Paulo', value: 'São Paulo'},
                    {text: 'Sergipe', value: 'Sergipe'},
                    {text: 'Tocantins', value: 'Tocantins'},
                ],
                name: '',
                email: '',
                tel: '',
                msg: '',
                cidade: '',
                estado: '',
                mensagem: '',
                show: false,
                emailError: '#373737'
            }
        },
        validations: {
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(10),
            },
            mensagem: {
                required,
                minLength: minLength(5),
            },
            tel: {
                required,
                minLength: minLength(8),
            },
            email: {
                required,
                email,
                minLength: minLength(8),
            },
            cidade: {
                required,
            },
            estado: {
                required,
            }
        },
        methods: {
            sendMessage() {
                if (this.name !== '' && this.email !== '' && this.tel !== '' && this.mensagem !== '' && this.cidade !== '' && this.estado !== ''
                ) {
                    if(!this.$v.email.email) {
                        this.emailError = 'red';
                        this.msg = 'Preencha o e-mail corretamente'
                        this.show = true;
                        setTimeout(() => {
                            this.show = false;
                        }, 2000);
                        return 
                    }
                    this.$root.mensagem = 'Mensagem enviada';
                    this.emailError = '#373737';
                    this.buttonText = 'Enviando...';
                    axios.post('/contact', {
                        name: this.name,
                        cidade: this.cidade,
                        email: this.email,
                        tel: this.tel,
                        msg: this.mensagem,
                        estado: this.estado,
                    })
                        .then(() => {
                            this.buttonText = 'Enviar';
                            this.msg = 'Sua mensagem foi enviada com sucesso';
                            this.show = true;
                            setTimeout(() => {
                                this.buttonText = 'Enviar mensagem'
                            }, 2000);
                            this.$router.push('/sucesso').catch(() => {
                            });
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth',
                            })
                        }).catch(() => {
                        this.buttonText = 'Enviar';

                        if (!this.$v.name.minLength) {
                            this.msg = 'Nome inválido, no mínimo 3 caractéres';
                        } else if (!this.$v.cidade.required) {
                            this.msg = 'O campo de cidade é obrigatório';
                        } else if (!this.$v.tel.minLength) {
                            this.msg = 'Telefone inválido, mínimo de 10 dígitos';
                        } else if (!this.$v.mensagem.minLength) {
                            this.msg = 'Mensagem inválida, mínimo de 10 caractéres';
                        } else if (!this.$v.email.minLength) {
                            this.msg = 'E-mail inválido, mínimo de 8 caractéres';
                        } else if (!this.$v.estado.required) {
                            this.msg = 'O estado é obrigatório';
                        } else {
                            this.msg = 'Houve um problema ao enviar a mensagem, tente novamente mais tarde';
                        }

                        this.show = true;
                        setTimeout(() => {
                            this.show = false;
                        }, 2000);
                        this.buttonText = 'Enviar';
                    })
                } else {
                    this.buttonText = 'Enviar';
                    this.msg = 'Preencha os campos que estão vazios';
                    this.show = true;
                    this.check();
                    setTimeout(() => {
                        this.show = false;
                    }, 2000)
                }
            },
            check(){
                let fields = [];
                let require = ["form_name",'form_email','form_tel','form_msg','form_cidade','form_estado'];

                if(this.name === ''){fields.push("form_name");}
                if(this.email === ''){fields.push("form_email");}
                if(this.tel === ''){fields.push("form_tel");}
                if(this.mensagem === ''){fields.push("form_msg");}
                if(this.cidade === ''){fields.push("form_cidade");}
                if(this.estado === ''){fields.push("form_estado");}
                require.forEach(this.unmark);
                fields.forEach(this.mark);

            },
            mark(item){
                const desc = document.querySelector('#' + item);
                desc.style.border = "1px solid red";
            },
            unmark(item){
                const desc = document.querySelector('#' + item);
                desc.style.border = "1px solid #373737";
            },
        },
        components: {
            TheMask,
            ModalConfirm
        }
    }
</script>

<style scoped lang="scss">
    .contact-form__title {
        font-family: "Roboto";
        font-weight: 500;
        margin: 60px 0 50px 0;
        font-size: 1.125rem;
        color: #b3b3b3;
    }

    .form-group-info, .form-group-personal, .form-group-msg {
        margin-bottom: 30px;
    }

    label {
        display: block;
        margin-bottom: 5px;
        font-size: 0.75rem;
        transition: all .3s ease;
        text-transform: uppercase;
        font-family: "Roboto";
        font-weight: 300;
    }

    input, textarea, select {
        width: 100%;
        border: 1px solid #373737;
        border-radius: 2px;
        padding: 15px;
        font-size: 1rem;
        font-family: 'Rubik', Arial, sans-serif;
        font-weight: 300;
        transition: all .3s ease;

        &:focus {
            outline: none;
            border-color: #2b2b2b;
        }
    }

    #form_estado {
        cursor: pointer;
    }

    .contact-form {
        margin-bottom: 115px;
        display: block;
        opacity: 1;
    }

    .form-group-personal {
        display: flex;
        justify-content: space-between;

        &__name {
            flex-grow: 1;
            display: flex;
            flex-direction: column-reverse;
        }

        &__lastname {
            flex-grow: 2;
            margin-left: 30px;
            display: flex;
            flex-direction: column-reverse;
        }

    }

    .form-group-info {
        display: flex;
        justify-content: space-between;

        &__email {
            flex-grow: 2;
            display: flex;
            flex-direction: column-reverse;
        }

        &__tel {
            flex-grow: 1;
            margin-left: 30px;
            display: flex;
            flex-direction: column-reverse;
        }

        &__cidade {
            flex-grow: 1;
            margin-right: 30px;

            display: flex;
            flex-direction: column-reverse;
        }

        &__estados {
            flex-grow: 1;
            display: flex;
            flex-direction: column-reverse;
        }
    }

    .form-group-msg {
        display: flex;
        flex-direction: column-reverse;

        label {
            margin-bottom: 20px;
            font-size: 1.125rem;
            text-transform: capitalize;
            color: #b3b3b3;
            font-family: "Roboto";
            font-weight: 500;
        }

        textarea {
            width: 100%;
            height: 300px;
        }
    }

    .form-group-btn {
        display: flex;
        justify-content: flex-end;
    }

    @media only screen and (max-width: 767px) {
        .contact-form__title {
            margin: 30px 0 40px 0;
        }

        .form-group-info__cidade {
            margin-right: 0;
            margin-top: -15px;
            margin-bottom: 15px;
        }

        .form-group-personal {
            flex-direction: column;

            &__lastname {
                margin-left: 0;
                margin-top: 15px;
            }
        }

        .form-group-info {
            flex-direction: column;

            &__tel {
                margin-top: 15px;
                margin-left: 0;
            }
        }
    }
</style>